import { Component, OnInit, ChangeDetectorRef, HostListener, OnDestroy } from '@angular/core';
import { map, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { ToastrService } from 'ngx-toastr';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { Router } from '@angular/router';
import { ProductService, ProductTypeValueService } from '@app/api/api';
import { environment } from 'environments/environment';
import $ from 'jquery';

@Component({
  selector: 'meu-hidden-product',
  templateUrl: './hidden-product.component.html',
  styleUrls: ['./hidden-product.component.scss'],
})
export class HiddenProductComponent implements OnInit, OnDestroy {
  public keyUp = new Subject<KeyboardEvent>();
  dataSearchBasic: any = '';
  filter = '';

  avatar = './assets/media/Image/product-demo.png';

  total = 0;
  pagesize = 10;
  pageIndex = 1;
  displayedColumns: string[] = [
    'index',
    'name',
    'SKU_type',
    'type',
    'price',
    'warehouse',
    'actions',
  ];

  pageSizeOptions: number[] = [5, 10, 20, 100];

  selection = new SelectionModel<Element>(true, []);

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.elementInView();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.elementInView();
  }

  _list = [];
  allProduct = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private toastr: ToastrService,
    private layoutUtilsService: LayoutUtilsService,
    private router: Router,
    private productService: ProductService,
    private productTypeValueService: ProductTypeValueService
  ) {}

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.pageIndex = 1;
        this.dataSearchBasic = value;
        this.filter = 'is_hidden==true,name|sapatco_code|product_code|sku@=' + this.dataSearchBasic;
        this.getListProduct();
      });
    this.filter = 'is_hidden==true';
    this.getListProduct();
  }

  ngOnDestroy() {
    this.changeDetectorRef.detach();
  }

  getListProduct() {
    this.productTypeValueService
      .apiFullProductsGet(this.filter, '', this.pageIndex, this.pagesize)
      .subscribe((res) => {
        if (res.success) {
          // this.pageIndex = res.data.pageIndex;
          // this.pagesize = res.data.pagesize;
          this.total = res.data.total;

          let list = [];

          for (let i = 0; i < res.data.collection.length; i++) {
            let listProduct = [];
            for (let j = 0; j < res.data.collection[i].type_values.length; j++) {
              listProduct.push({
                id: res.data.collection[i].product.id,
                SKU_type: '',
                type: res.data.collection[i].type_values[j].extend_type_names,
                price: res.data.collection[i].type_values[j].price,
                warehouse: res.data.collection[i].type_values[j].quantity,
                index: j,
              });
            }
            if (res.data.collection[i].type_values.length == 0) {
              listProduct.push({
                id: res.data.collection[i].product.id,
                SKU_type: '',
                type: null,
                price: res.data.collection[i].product.price,
                warehouse: res.data.collection[i].product.quantity,
                index: 0,
              });
            }

            list.push({
              id: res.data.collection[i].product.id,
              product_id: res.data.collection[i].product.id,
              avatar: environment.backendhost + res.data.collection[i].product.default_image,
              name: res.data.collection[i].product.name,
              lock: res.data.collection[i].product.is_hidden,
              SKU_product: res.data.collection[i].product.sku,
              listProduct: listProduct,
            });
          }

          this._list = list;

          let all_product = [];

          for (let i = 0; i < this._list.length; i++) {
            all_product.push({
              id: this._list[i].id,
              product_id: this._list[i].product_id,
              avatar: this._list[i].avatar,
              name: this._list[i].name,
              lock: this._list[i].lock,
              SKU_product: this._list[i].SKU_product,
              numberProductLoadMore: this._list[i].listProduct.length - 2,
              showAll: false,
              listProduct: [],
            });
            for (let j = 0; j < this._list[i].listProduct.length && j < 2; j++) {
              all_product[i].listProduct.push({
                id: this._list[i].listProduct[j].id,
                SKU_type: this._list[i].listProduct[j].SKU_type,
                type: this._list[i].listProduct[j].type,
                price: this._list[i].listProduct[j].price,
                warehouse: this._list[i].listProduct[j].warehouse,
                index: this._list[i].listProduct[j].index,
              });
            }
          }

          this.allProduct = all_product;

          if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
          }
        } else {
          this.toastr.error(res.message, 'Đã xảy ra lỗi');
        }
      });
  }

  advSearch() {}
  editProduct(productID) {
    this.router.navigate(['admin/product-management/' + productID + '/edit']);
  }

  deleteProduct(productID) {
    const title = 'Xóa sản phẩm';
    const description = 'Bạn có chắc chắn muốn xóa sản phẩm này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.productService.apiProductsIdDelete(productID).subscribe((res) => {
        if (res.success) {
          this.getListProduct();
          this.toastr.success('Đã xóa thành công');
        } else {
          this.toastr.error(res.message, 'Xóa không thành công');
        }
      });
    });
  }

  loadMore(parentProductId) {
    let index = this.allProduct.findIndex((x) => x.id == parentProductId);
    this.allProduct[index].listProduct = this._list[index].listProduct;
    this.allProduct[index].showAll = true;
  }

  hidden(parentProductId) {
    let index = this.allProduct.findIndex((x) => x.id == parentProductId);
    this.allProduct[index].listProduct = this._list[index].listProduct.slice(0, 2);
    this.allProduct[index].showAll = false;
    this.allProduct[index].numberProductLoadMore = this._list[index].listProduct.length - 2;
  }

  elementInView() {
    if (this.selection.selected.length > 0) {
      var elmnt = document.getElementById('section-search');
      let widthElement = elmnt.offsetWidth - 20;

      const pageTop = $(window).scrollTop();
      const pageBottom = pageTop + $(window).height();
      const elementTop = $('#footer').offset().top;
      const elementBottom = elementTop + $('#footer').height();
      if (!(elementTop <= pageBottom && elementBottom >= pageTop)) {
        $('.desktop-actions-footer').addClass('kt-footer-mobile kt-footer--fixed');
        $('.desktop-actions-footer').attr('id', 'fixed-footer');
        document.getElementById('fixed-footer').style.width = widthElement + 'px';
      } else {
        $('.desktop-actions-footer').removeClass('kt-footer-mobile kt-footer--fixed');
        $('.desktop-actions-footer').removeAttr('id');
        $('.desktop-actions-footer').removeAttr('style');
      }
    }
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.selection.clear();
      this.pageIndex = pageNumber;
      this.getListProduct();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.selection.clear();
    this.pagesize = newSize;
    this.pageIndex = 1;
    this.getListProduct();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.allProduct.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.allProduct.forEach((row) => this.selection.select(row));
  }

  async show() {
    for (let i = 0; i < this.selection.selected.length; i++) {
      if (this.selection.selected[i]['lock']) {
        let obj: any = {
          is_hidden: false,
        };
        await this.productService
          .apiProductsIdPut(this.selection.selected[i]['product_id'], obj)
          .toPromise()
          .then((res) => {
            if (res.success) {
              if (i + 1 == this.selection.selected.length) {
                this.toastr.success('Thao tác thành công');
                this.selection.clear();
                this.getListProduct();
              }
            }
          });
      }
    }
  }

  subStringName(name) {
    if (name) {
      let l = name.toString().length;
      if (l > 40) {
        return name.substring(0, 40) + '...';
      } else {
        return name;
      }
    }
    return '';
  }

  deleteMultipleProduct() {
    const title = 'Xóa tất cả sản phẩm đang chọn';
    const description = 'Bạn có chắc chắn muốn xóa những sản phẩm này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe(async (res) => {
      if (!res) {
        return;
      }
      for (let i = 0; i < this.selection.selected.length; i++) {
        await this.productService
          .apiProductsIdDelete(this.selection.selected[i]['product_id'])
          .toPromise()
          .then((res) => {
            if (res.success) {
              if (i + 1 == this.selection.selected.length) {
                this.toastr.success('Thao tác xóa thành công');
                this.selection.clear();
                this.getListProduct();
              }
            }
          });
      }
    });
  }
}
